var chunkMapping = {
	"webpack_container_remote_CHECKOUT_HcpSlice-webpack_container_remote_CHECKOUT_addressSlice": [
		77867,
		98328
	],
	"src_bootstrap_js-src_assets_images_loader_gif-node_modules_pure-react-carousel_dist_react-car-afe45b": [
		86908,
		55077,
		93421,
		16792,
		93894,
		42413,
		75021,
		82013,
		73913,
		84090,
		79144,
		66318,
		17240,
		73882,
		94468,
		12594,
		85206,
		24253,
		78972,
		77216,
		55169,
		10497,
		68266,
		15089,
		99601,
		87949,
		20729,
		21228,
		16422
	],
	"src_components_PersonalizeMessageOption_index_js": [
		28602
	],
	"src_components_SearchResults_index_js": [
		61953
	],
	"src_components_ItemDetails_index_js": [
		94324
	],
	"src_components_MarketingMaterial_index_js": [
		78119
	],
	"src_components_ECheckOut_index_js": [
		32866
	],
	"webpack_container_remote_ItemDetails_CustomizeTemplates": [
		33057
	],
	"src_components_TemplateDetail_index_js": [
		53075
	],
	"src_components_EmailDetail_index_js": [
		94044
	],
	"src_components_CheckOut_index_js": [
		97911
	],
	"src_components_OrderDetail_index_js": [
		99129
	],
	"src_components_TemplateSetup_index_js": [
		78464
	],
	"src_components_ManageStateShipWith_index_js": [
		37339
	],
	"src_components_Cart_index_js": [
		66227
	],
	"src_components_Collections_CreateCollection_index_js": [
		71198
	],
	"src_components_Collections_ModifyCollection_index_js": [
		87124
	],
	"src_components_Collections_index_js": [
		99103
	],
	"src_components_UserProfile_index_js": [
		30452
	],
	"src_components_SalesTeam_index_js": [
		14121
	],
	"src_components_AttributeSalesTeam_index_js": [
		36841
	],
	"src_components_OrderSearch_index_js": [
		32430
	],
	"src_components_shippingType_index_js": [
		41520
	],
	"src_components_UserRole_AllUserRoles_index_js": [
		6497
	],
	"src_components_UserRole_UserRoleDetail_index_js": [
		91326
	],
	"src_components_UserRole_CreateUserRole_index_js": [
		37073
	],
	"src_components_EmailManagement_index_js": [
		11396
	],
	"src_components_Account_index_js": [
		33209
	],
	"src_components_ProductDisplay_index_js": [
		26000
	],
	"src_components_UserSearch_index_js": [
		96276
	],
	"src_components_CreateUser_index_js": [
		76001
	],
	"src_components_ShipMethods_shipToHcp_js": [
		8736
	],
	"src_components_ShipMethods_HcpCustomFeature_js": [
		89651
	],
	"src_components_ShipMethods_ShipToDistribution_js": [
		13117
	],
	"src_components_OrderDetailComp_index_js": [
		12053
	],
	"src_components_Support_index_js": [
		27017
	],
	"src_components_ValidForUse_index_js": [
		6876
	],
	"src_components_ViewAllTemplates_index_js": [
		44511
	],
	"src_components_SiteAdministration_index_js": [
		16862
	],
	"src_components_AddNewMessage_index_js": [
		39606
	],
	"src_components_AddressBook_index_js": [
		43345
	],
	"src_components_AddressBook_AddressBookCreateEdit_js": [
		38348
	],
	"src_components_ShippingMethodsAssignment_index_js": [
		46157
	]
};
var idToExternalAndNameMapping = {
	"6497": [
		"default",
		"./UserRole",
		63602
	],
	"6876": [
		"default",
		"./ReportsComp",
		63602
	],
	"8736": [
		"default",
		"./ShipToHcp",
		85942
	],
	"10497": [
		"default",
		"./announcementSlice",
		63602
	],
	"11396": [
		"default",
		"./EmailManagementComp",
		63602
	],
	"12053": [
		"default",
		"./OrderDetailInfo",
		85942
	],
	"12594": [
		"default",
		"./Hcp360Slice",
		85942
	],
	"13117": [
		"default",
		"./ShipToDistribution",
		85942
	],
	"14121": [
		"default",
		"./SalesTeamIndex",
		63602
	],
	"15089": [
		"default",
		"./userAllocationApi",
		63602
	],
	"16422": [
		"default",
		"./collectionApi",
		36413
	],
	"16792": [
		"default",
		"./templateDetailSlice",
		39941
	],
	"16862": [
		"default",
		"./SiteAdministrationComp",
		63602
	],
	"17240": [
		"default",
		"./cartSlice",
		77067
	],
	"20729": [
		"default",
		"./FooterComp",
		63057
	],
	"21228": [
		"default",
		"./api",
		77067
	],
	"24253": [
		"default",
		"./shipToDistributionSlice",
		85942
	],
	"26000": [
		"default",
		"./ProductDisplayComp",
		63602
	],
	"27017": [
		"default",
		"./Support",
		63602
	],
	"28602": [
		"default",
		"./PersonalizeMessageOption",
		85942
	],
	"30452": [
		"default",
		"./UserProfileIndex",
		63602
	],
	"32430": [
		"default",
		"./OrderSearch",
		85942
	],
	"32866": [
		"default",
		"./ECheckoutComp",
		85942
	],
	"33057": [
		"default",
		"./CustomizeTemplates",
		39941
	],
	"33209": [
		"default",
		"./Account",
		63602
	],
	"36841": [
		"default",
		"./AttributeSalesTeamIndex",
		63602
	],
	"37073": [
		"default",
		"./UserRoleCreate",
		63602
	],
	"37339": [
		"default",
		"./ManageStateShipWithComp",
		63602
	],
	"38348": [
		"default",
		"./AddressBookCreateEdit",
		30417
	],
	"39606": [
		"default",
		"./AddStandardMessages",
		63602
	],
	"41520": [
		"default",
		"./ShippingType",
		85942
	],
	"42413": [
		"default",
		"./SalesTeamSliceIndex",
		63602
	],
	"43345": [
		"default",
		"./AddressBookComp",
		30417
	],
	"44511": [
		"default",
		"./ViewAllTemplatesComp",
		39941
	],
	"46157": [
		"default",
		"./ShippingMethodsAssignmentIndex",
		63602
	],
	"53075": [
		"default",
		"./TemplateDetailComp",
		39941
	],
	"55077": [
		"default",
		"./ReportsSlice",
		63602
	],
	"55169": [
		"default",
		"./supportSlice",
		63602
	],
	"61953": [
		"default",
		"./SearchResultsComp",
		43489
	],
	"66227": [
		"default",
		"./CartComp",
		77067
	],
	"66318": [
		"default",
		"./messagesSlice",
		63602
	],
	"68266": [
		"default",
		"./AddressBookSlice",
		30417
	],
	"71198": [
		"default",
		"./CreateCollection",
		36413
	],
	"73882": [
		"default",
		"./orderSlice",
		77067
	],
	"73913": [
		"default",
		"./product",
		63602
	],
	"75021": [
		"default",
		"./userSearch",
		63602
	],
	"76001": [
		"default",
		"./CreateUser",
		63602
	],
	"77216": [
		"default",
		"./orderSearchSlice",
		85942
	],
	"77867": [
		"default",
		"./HcpSlice",
		85942
	],
	"78119": [
		"default",
		"./MarketingMaterialComp",
		39941
	],
	"78464": [
		"default",
		"./TemplateSetupComp",
		63602
	],
	"78972": [
		"default",
		"./collectionSlice",
		36413
	],
	"79144": [
		"default",
		"./messagesApi",
		63602
	],
	"82013": [
		"default",
		"./user",
		63602
	],
	"84090": [
		"default",
		"./emailSlice",
		63602
	],
	"85206": [
		"default",
		"./ShippingTypeSlice",
		85942
	],
	"86908": [
		"default",
		"./SearchSlice",
		43489
	],
	"87124": [
		"default",
		"./CollectionModify",
		36413
	],
	"87949": [
		"default",
		"./HeaderComp",
		34416
	],
	"89651": [
		"default",
		"./HcpCustomFeatures",
		85942
	],
	"91326": [
		"default",
		"./UserRoleDetail",
		63602
	],
	"93421": [
		"default",
		"./itemDetailSlice",
		39941
	],
	"93894": [
		"default",
		"./userProfileSlice",
		63602
	],
	"94044": [
		"default",
		"./EmailDetailsComp",
		39941
	],
	"94324": [
		"default",
		"./ItemDetailComp",
		39941
	],
	"94468": [
		"default",
		"./CheckoutSlice",
		85942
	],
	"96276": [
		"default",
		"./UserSearchComp",
		63602
	],
	"97911": [
		"default",
		"./CheckoutComp",
		85942
	],
	"98328": [
		"default",
		"./addressSlice",
		85942
	],
	"99103": [
		"default",
		"./CollectionComp",
		36413
	],
	"99129": [
		"default",
		"./OrderDetail",
		85942
	],
	"99601": [
		"default",
		"./personalizeMessageSlice",
		85942
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}